//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  QCard,
  QCardSection
} from 'quasar'

export default {
  name: 'PasswordCard',
  components: {
    QCard,
    QCardSection
  },
  data () {
    return {
      password: '',
      isPwd: true
    }
  },
  methods: {
    updatePassword (password) {
      this.$store.commit('EDIT_PASSWORD', password)
    }
  }
}
